// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2dLoF","footer":"ReportModalFilter_footer__LIyKt"};